/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_PriceInputs */

const en_fc_home_spec_price = /** @type {(inputs: Fc_Home_Spec_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Fc_Home_Spec_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_price = /** @type {((inputs?: Fc_Home_Spec_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_PriceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_price(inputs)
});
export { fc_home_spec_price as "fc.home.spec.price" }